'use client';

interface ErrorProps {
    error: Error & { digest?: string };
    reset: () => void;
}

export default function Error({ reset }: ErrorProps) {
    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center col-12"
            style={{ height: '100dvh' }}
        >
            <p className="h5 fw-bold text-white mb-3">Something went wrong</p>
            <button className="btn btn-outline-light" onClick={() => reset()}>
                Try Again
            </button>
        </div>
    );
}
